import { render } from "./CFODashboard.vue?vue&type=template&id=d4077d82&scoped=true"
import script from "./CFODashboard.vue?vue&type=script&lang=js"
export * from "./CFODashboard.vue?vue&type=script&lang=js"

import "./CFODashboard.vue?vue&type=style&index=0&id=d4077d82&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4077d82"]])

export default __exports__